import { gql } from '@apollo/client';

export const mutationCreateClientContract = gql`
  mutation CreateClientContractMutation($input: CreateClientContractMutationInput!) @api(name: admin) {
    createClientContract(input: $input) {
      clientContract {
        id
        title
        company {
          id
          title
          country {
            id
            name
          }
          city {
            id
            name
          }
          address1
          zip
          vatNumber
          website
          email
        }
        defaultBank {
          id
          title
        }
        reference
        defaultTerms {
          id
          title
        }
        startDate
        endDate
        state
        primaryContact {
          id
          firstName
          lastName
        }
        toInvoice {
          id
          firstName
          lastName
        }
        forOrders {
          id
          firstName
          lastName
        }
        forPaymentNotifications {
          id
          firstName
          lastName
        }
        forNotifications {
          id
          firstName
          lastName
        }
        officialName
        officialContractStartDate
        isMobile
        isShareBuild
      }
      errors {
        messages
      }    
    }
  } 
`;
